import { actions, types } from './requests'
export const GETARTICLE_TYPES = {
    ...types('GETARTICLE'),
}
export const GETARTICLE_ACTIONS = {
    ...actions('GETARTICLE'),
}
